import { Card, FooterMenu } from "components"
import moment from "moment"
import { SelectedState } from "pages/FindSection/types"
import { Fragment, useEffect, useState } from "react"
import { FilterSection, TableSection } from "./components"
import { exportExcelFindInventory } from "./functions"
import { useExportPdfFindInventory, useList } from "./hooks"
import { useLocation } from "react-router-dom"

export function FindByInventory() {
  const location = useLocation()
  const path = location?.pathname.split("/")
  const firstPath = path[1]

  const [selected, setSelected] = useState<SelectedState>({
    date_from: "",
    date_end: "",
    search_by: "",
    search_id: ""
  })
  const exportDateFormat = `${moment(selected.date_from).format("DD/MM/YYYY")} - ${moment(selected.date_end).format("DD/MM/YYYY")}`
  const { data, isLoading, refetch } = useList()
  const exportPdf = useExportPdfFindInventory({
    data: data,
    dateFilter: exportDateFormat ?? "",
    module: firstPath?.toUpperCase()
  })

  useEffect(() => {
    const filteredSelected: Partial<SelectedState> = {}

      ; (Object.keys(selected) as Array<keyof SelectedState>).forEach((key) => {
        if (selected[key]) {
          filteredSelected[key] = selected[key]
        }
      })

    refetch(filteredSelected)

    // eslint-disable-next-line
  }, [selected])

  return (
    <Fragment>
      <FilterSection selected={selected} setSelected={setSelected} />
      <section className="mt-2">
        <Card>
          <Card.Body>
            <TableSection
              data={data}
              isLoading={isLoading}
              refetch={refetch}
              selected={selected}
            />
          </Card.Body>
        </Card>
      </section>
      <FooterMenu
        export={{
          actiontype: "export",
          onClick: () =>
            exportExcelFindInventory({
              data: data,
              dateFilter: exportDateFormat,
              module: firstPath?.toUpperCase()
            })
        }}
        pdf={{ actiontype: "pdf", onClick: exportPdf.handleExportPdf }}
      />
    </Fragment>
  )
}
